import React from "react";

import clsx from "clsx";

import TailwickContactAvatar from "../ChatLayout/TailwickContactAvatar";
import { dedupeTagsById } from "../../helpers/normalizeContactTags";
import { i18n } from "../../translate/i18n";


const iconBtn =

	"tailwick-chat-item__icon-btn inline-flex shrink-0 items-center justify-center border-0 bg-transparent p-0 transition-opacity hover:opacity-70 disabled:opacity-40";



function getTagSizeClass(name) {
	const len = String(name || "").length;
	if (len <= 8) return "tailwick-chat-item__tag--sm";
	if (len <= 14) return "tailwick-chat-item__tag--md";
	return "tailwick-chat-item__tag--lg";
}

function ContentBlock({ contactName, lastMessagePreview, timeLabel, connectionName }) {
	const showConnection = Boolean(String(connectionName || "").trim());

	return (
		<div className="min-w-0 flex-1">
			<div className="tailwick-chat-item__head flex items-center gap-2">
				<h6 className="min-w-0 flex-1 truncate font-semibold leading-tight text-default-800">
					{contactName}
				</h6>
				{showConnection && (
					<span
						className="tailwick-chat-item__connection-badge shrink-0"
						title={i18n.t("ticketsList.connectionTitle")}
					>
						{connectionName}
					</span>
				)}
				{timeLabel && (
					<small className="tailwick-chat-item__time shrink-0 leading-none text-default-500">
						{timeLabel}
					</small>
				)}
			</div>
			<p className="tailwick-chat-item__meta mt-0.5 min-w-0 truncate leading-snug text-default-500">
				{lastMessagePreview || "\u00A0"}
			</p>
		</div>
	);
}

const MAX_CONTACT_TAGS = 2;

function getQueueBadgeStyle(color) {
	const hex = String(color || "#7C7C7C").trim();
	return {
		backgroundColor: `${hex}1a`,
		borderColor: `${hex}4d`,
		color: hex,
	};
}

function ItemFooter({ ticket, queueColor }) {
	const tags = dedupeTagsById(ticket?.contact?.tags || []);
	const hasAgent = Boolean(ticket?.user);
	const visibleTags = tags.slice(0, MAX_CONTACT_TAGS);
	const hiddenTags = tags.slice(MAX_CONTACT_TAGS);
	const hiddenTitle = hiddenTags.map((tag) => tag.name).join(", ");
	const hasTags = visibleTags.length > 0 || hiddenTags.length > 0;
	const agentBadgeStyle = getQueueBadgeStyle(
		ticket?.queue?.color || queueColor
	);

	return (
		<div
			className="tailwick-chat-item__footer"
			aria-hidden={!hasAgent && !hasTags}
		>
			{hasAgent && (
				<span
					className="tailwick-chat-item__agent-badge"
					style={agentBadgeStyle}
					title={`${i18n.t("messagesList.header.assignedTo")} ${ticket.user.name}`}
				>
					{ticket.user.name}
				</span>
			)}
			{hasTags && (
				<div className="tailwick-chat-item__tags">
					{visibleTags.map((tag, index) => (
						<span
							key={tag.id != null ? tag.id : `tag-${index}`}
							className={clsx(
								"tailwick-chat-item__tag",
								getTagSizeClass(tag.name)
							)}
							style={{ backgroundColor: tag.color || "#64748b" }}
							title={tag.name}
						>
							{tag.name}
						</span>
					))}
					{hiddenTags.length > 0 && (
						<span
							className="tailwick-chat-item__tag tailwick-chat-item__tag--more"
							title={hiddenTitle}
						>
							+{hiddenTags.length}
						</span>
					)}
				</div>
			)}
		</div>
	);
}



function PendingIconActions({ ticket, loading, onAcceptNoQueue, onAccept, onView }) {

	return (

		<div className="tailwick-chat-item__actions flex items-center gap-2">

			{(ticket.queue === null || ticket.queue === undefined) && (

				<button

					type="button"

					className={clsx(iconBtn, "text-primary")}

					title={i18n.t("ticketsList.items.accept")}

					onClick={onAcceptNoQueue}

				>

					<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>

						<path d="M20 6 9 17l-5-5" />

					</svg>

				</button>

			)}

			{ticket.queue !== null && ticket.queue !== undefined && (

				<button

					type="button"

					disabled={loading}

					className={clsx(iconBtn, "text-primary")}

					title={i18n.t("ticketsList.items.accept")}

					onClick={onAccept}

				>

					<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>

						<path d="M20 6 9 17l-5-5" />

					</svg>

				</button>

			)}

			<button

				type="button"

				className={clsx(iconBtn, "text-default-500 hover:text-primary")}

				title={i18n.t("ticketsList.items.spy")}

				onClick={onView}

			>

				<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>

					<path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" />

					<circle cx="12" cy="12" r="3" />

				</svg>

			</button>

		</div>

	);

}



function RightColumn({ unreadCount, isPendingRow, pendingProps }) {

	if (isPendingRow) {

		return pendingProps ? (

			<div className="tailwick-chat-item__side flex shrink-0">

				<PendingIconActions {...pendingProps} />

			</div>

		) : null;

	}



	if (unreadCount <= 0) return null;



	return (

		<div className="tailwick-chat-item__side flex shrink-0">

			<span className="flex h-4 min-w-[1rem] items-center justify-center rounded-full bg-primary px-1 text-[10px] font-semibold leading-none text-white">

				{unreadCount > 99 ? "99+" : unreadCount}

			</span>

		</div>

	);

}



/**

 * Item de conversa Tailwick — badge do responsável antes das tags (estilo Employee Performance).

 */

export default function TicketListItemTailwick({
	ticket,
	isActive,
	contactName,
	lastMessagePreview,
	timeLabel,
	unreadCount,
	queueColor,
	queueLabel,
	connectionName,
	onSelect,
	onAcceptNoQueue,
	onAccept,
	onView,
	loading,
	bulkSelection,
	bulkSelected=[],
	setBulkSelected
}) {
	const isPendingRow = ticket.status === "pending";

	const itemClass = clsx(
		"tailwick-chat-item group flex w-full items-stretch border-0 text-left transition-colors",
		!isPendingRow && "cursor-pointer",
		isActive ? "bg-default-200" : !isPendingRow && "hover:bg-default-150"
	);

	const rowClass = "tailwick-chat-item__row flex min-w-0 flex-1 flex-col";
	const topRowClass = "flex min-w-0 items-start gap-3";

	const pendingProps = isPendingRow
		? { ticket, loading, onAcceptNoQueue, onAccept, onView }
		: null;

	const queueStrip = (
		<span
			className="tailwick-chat-item__queue-strip"
			style={{ backgroundColor: queueColor || "#7C7C7C" }}
			title={queueLabel || undefined}
			aria-hidden
		/>
	);

	const rowContent = (
		<div className={topRowClass}>
			<TailwickContactAvatar
				size="sm"
				contactId={ticket?.contact?.id}
				profilePicUrl={ticket?.contact?.profilePicUrl}
				isGroup={Boolean(ticket?.contact?.isGroup)}
				channel={ticket?.channel}
				contactChannel={ticket?.contact?.channel}
				statusHighlight={Boolean(ticket?.isStatus)}
				syncProfilePic={false}
			/>
			<div className="tailwick-chat-item__body">
				<div className="flex min-w-0 items-start gap-2">
					<ContentBlock
						contactName={contactName}
						lastMessagePreview={lastMessagePreview}
						timeLabel={timeLabel}
						connectionName={connectionName}
					/>
					<RightColumn
						unreadCount={unreadCount}
						isPendingRow={isPendingRow}
						pendingProps={pendingProps}
					/>
				</div>
				<ItemFooter ticket={ticket} queueColor={queueColor} />
			</div>
		</div>
	);

	const checkboxSelection = (
		<input type="checkbox"
			name="bulkSelected"
			style={{ transform: "scale(1.6)",marginRight:"1rem", marginLeft:"0.3rem"}}
			checked={bulkSelected.indexOf(ticket.id) !== -1}
			onChange={(e) => {
				if(bulkSelected.length < 50 || !e.target.checked){
					setBulkSelected(prev =>
						prev.some(i => i === ticket.id)
							? prev.filter(i => i !== ticket.id)
							: [...prev, ticket.id]
					)
				}
			}}
			value={ticket.id}
		/>
	)

	if (isPendingRow) {
		return (
			<div className={itemClass}>
				{bulkSelection &&  checkboxSelection}
				{queueStrip}
				<div className={rowClass}>{rowContent}</div>
			</div>
		);
	}
	return (
		<div className="flex items-center gap-2">
			{bulkSelection &&  checkboxSelection}
			<button type="button" onClick={onSelect} className={itemClass}>
				{queueStrip}
				<div className={rowClass}>{rowContent}</div>
			</button>
		</div>
	);
}
